<div class="private-schedule">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="privateForm">
          <form [formGroup]="privateScheduleForm">
            <div *ngIf="isFormLoaded">
              <div class="button-group">
                <button mat-raised-button class="btn-warn" color="" (click)="back()">
                  {{'test.editSchedule.btnBack' | translate}}
                </button>
                <div class="btn-right">
                  <button mat-flat-button color="" (click)="cancelTestSchedule()"
                    [disabled]="isCompleted || (rolSer.accessData && !rolSer.accessData.deleteAllowed)" class="btn-primary"
                    aria-label="Cancel Schedule">{{'test.editSchedule.btnCancel' | translate}}</button>
                  <button mat-raised-button class="btn-primary" color="" [disabled]="privateScheduleForm.status=='INVALID'? true: false
                    || isCompleted || selectedExaminees.length === 0 ? true :
                    false || isEndTimeValid || isStartTimeValid" (click)="onSubmit(privateScheduleForm)">
                    {{'test.editSchedule.btnSave' | translate}}</button>
                </div>
              </div>
              <div class="form-group ptb-padding">
                <label for="Schedule name">{{'test.editSchedule.private.labelName' | translate}}<span class="red-asterisk">*</span></label>
                <input type="text" autocomplete="off" class="form-control" id="schName" aria-describedby="scheduleName" maxlength="121"
                  formControlName="schName" [disabled]="isCompleted">
                <div *ngIf="f.schName.invalid && (f.schName.dirty ||
                  f.schName.touched )" >
                  <div class="alert alert-danger" *ngIf="f.schName.errors?.required">
                    {{'test.editSchedule.private.nameError1' | translate}}
                  </div>
                  <div class="alert alert-danger" *ngIf="f.schName.errors?.minlength">
                    {{'test.editSchedule.private.nameError2' | translate}}
                  </div>
                  <div class="alert alert-danger" *ngIf="f.schName.errors?.maxlength">
                    {{'test.editSchedule.private.nameError3' | translate}}
                  </div>
                </div>

              </div>
              <div class="form-group">
                <label for="Schedule description">{{'test.editSchedule.private.labelDesc' | translate}}</label>
                <textarea class="form-control" type="text" maxlength="481" id="schDescription" aria-describedby="scheduledescription" value=""
                  name="schDescription" formControlName="schDescription" [disabled]="isCompleted"></textarea>
                <div *ngIf="f.schDescription.invalid && (f.schDescription.dirty ||
                  f.schDescription.touched )" class="alert alert-danger">
                  <!-- <div *ngIf="f.schDescription.errors?.minlength">Minimum 3 characters required</div> -->
                  <div *ngIf="f.schDescription.errors?.maxlength">{{'test.editSchedule.private.descError2' | translate}}</div>
                </div>
              </div>
              <div class="form-group details ptb-padding">
                <div class="filter-section title mb-margin"> <strong>{{'test.editSchedule.private.labelDetail' | translate}}
                  </strong> </div>
                <!-- <label for="">Add recipient*</label> -->

                <!-- <mat-form-field class="chip-list">
                                  <mat-label>Add recipient<span class="red-asterisk">*</span></mat-label>
                                  <mat-chip-list #chipList>
                                      <mat-chip *ngFor="let examinee of chipSelectedExaminee" [selectable]=true
                                          [removable]=true (removed)="removeExaminee(examinee)">
                                          {{examinee.fullName}}
                                          <mat-icon matChipRemove>cancel</mat-icon>
                                      </mat-chip>
                                      <input placeholder="" required #examineeInput [formControl]="examineeControl"
                                          [matAutocomplete]="auto" [matChipInputFor]="chipList"
                                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                          [matChipInputAddOnBlur]=true (matChipInputTokenEnd)="addExaminee($event)">
                                  </mat-chip-list>
                                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedExaminee($event)">
                                      <mat-option *ngFor="let thisExamineeName of filteredExaminee | async"
                                          [value]="thisExamineeName">
                                          {{thisExamineeName}}
                                      </mat-option>
                                  </mat-autocomplete>
                              </mat-form-field>
                              <div *ngIf="isExamineeNotExist" class="alert alert-danger">Please add at least 1 recipient
                              </div> -->
                <div class="btn-add-examinee-wrapper">
                  <label for="">{{'test.editSchedule.private.labelExaminees' | translate}}<span class="red-asterisk">*</span></label>
                  <div class="btn-add-examinee">
                    <button mat-raised-button class="btn-warn" color="" [disabled]="isCompleted" (click)="addRecipientDialogbox()">+
                      {{'test.editSchedule.private.btnExaminees' | translate}}</button>
                  </div>
                </div>
                <mat-chip-list aria-label="examinee selection">
                  <mat-chip *ngFor="let chip of selectedExaminees" [disabled]="
                    isCompleted">
                    {{chip?.fullName}}
                    <button class="btn-icon" (click)="removeExamineeFromArray(chip)" [disabled]="
                      isCompleted">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-chip>
                </mat-chip-list>
                <div *ngIf="isExamineeNotExist" class="alert alert-danger">{{'test.editSchedule.private.examineeError1' | translate}}</div>
              </div>
              <div class="form-group date-n-time pb-padding pt-padding">
                <div class="row">
                  <div class="col-md-2">
                    <div class="input-class">
                      <label for="">{{'test.editSchedule.private.dateAndTime.startDate' | translate}}<span class="red-asterisk">*</span></label>
                      <mat-form-field class="example-full-width" appearance="fill">
                        <mat-label></mat-label>
                        <input matInput [matDatepicker]="picker" [min]="minDate" [disabled]="isLive" formControlName="startDate" readonly/>
                        <!-- <input matInput [matDatepicker]="picker" formControlName="startDate"> -->
                        <mat-datepicker-toggle matSuffix [for]="picker">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>

                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>

                      <div *ngIf="f.startDate.invalid && (f.startDate.dirty ||
                        f.startDate.touched )" class="alert alert-danger"> Start Date is invalid
                        <div *ngIf="f.startDate.errors?.required">Start Date is
                          required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 date-class">
                    <div class="input-time">
                      <label class="timepicker" for="">{{'test.editSchedule.private.dateAndTime.startTime' | translate}}<span class="red-asterisk">*</span></label>
                      <!-- <ngx-timepicker-field [format]="24" aria-disabled="true" [defaultTime]="'00:00'" formControlName="startTime">
                      </ngx-timepicker-field> -->
                      <ngx-timepicker-field [format]="24" aria-disabled="true" [defaultTime]="'00:00'"
                        formControlName="startTime" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="okBtn">
                      </ngx-timepicker-field>
                      <ng-template #cancelBtn>
                        <button class="clock">
                          {{'test.editSchedule.private.dateAndTime.btnCancel' | translate}} </button>
                      </ng-template>
                      <ng-template #okBtn>
                        <button class="clock">
                          {{'test.editSchedule.private.dateAndTime.btnOk' | translate}}</button>
                      </ng-template>


                      <div *ngIf="isStartTimeValid" class="alert alert-danger">
                        {{'test.editSchedule.private.dateAndTime.startTimeError1' | translate}}
                      </div>
                      <!-- <div *ngIf="f.startTime.invalid && (f.startTime.dirty || f.startTime.touched ) "
                                              class="alert alert-danger">
                                              <div *ngIf="f.startTime.errors?.required">Start Time is required</div>
                                          </div> -->
                    </div>
                  </div>

                  <div class="col-md-2 date-class">
                    <div class="input-class">
                      <label for="">{{'test.editSchedule.private.dateAndTime.endDate' | translate}}<span class="red-asterisk">*</span></label>
                      <mat-form-field class="example-full-width" appearance="fill">
                        <!-- <mat-label>End date</mat-label> -->
                        <input matInput [matDatepicker]="picker1" [min]="minDate1" formControlName="endDate" readonly/>
                        <!-- <input matInput [matDatepicker]="picker1" formControlName="endDate"> -->
                        <mat-datepicker-toggle matSuffix [for]="picker1">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                      </mat-form-field>
                      <div *ngIf="f.endDate.invalid && (f.endDate.dirty ||
                        f.endDate.touched )" class="alert alert-danger"> End Date is invalid
                        <div *ngIf="f.endDate.errors?.required">End Date is
                          required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 date-class">
                    <div class="input-time">
                      <label class="timepicker" for="">{{'test.editSchedule.private.dateAndTime.endTime' | translate}}<span class="red-asterisk">*</span></label>
                      <!-- <ngx-timepicker-field [format]="24" [defaultTime]="'00:00'" formControlName="endTime">
                      </ngx-timepicker-field> -->
                      <ngx-timepicker-field [format]="24" aria-disabled="true" [defaultTime]="'00:00'"
                        formControlName="endTime" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="okBtn">
                      </ngx-timepicker-field>
                      <ng-template #cancelBtn>
                        <button class="clock">
                          {{'test.editSchedule.private.dateAndTime.btnCancel' | translate}} </button>
                      </ng-template>
                      <ng-template #okBtn>
                        <button class="clock">
                          {{'test.editSchedule.private.dateAndTime.btnOk' | translate}}</button>
                      </ng-template>


                      <div *ngIf="isEndTimeValid" class="alert alert-danger">
                        {{'test.editSchedule.private.dateAndTime.endTimeError1' | translate}}
                      </div>
                      <!-- <div *ngIf="f.endTime.invalid && (f.endTime.dirty || f.endTime.touched )"
                                              class="alert alert-danger">
                                              <div *ngIf="f.endTime.errors?.required">End Time is required</div>
                                          </div> -->
                    </div>
                  </div>
                  <div class="col-md-3 date-class">
                    <div class="input-class">
                      <label class="timepicker">{{'test.editSchedule.private.dateAndTime.timezone' | translate}}<span class="red-asterisk">*</span></label>
                      <mat-select class="form-control timeZ" [(value)]="timeZoneName" [disabled]="isCompleted">
                        <mat-select-filter [array]="searchOptions" [displayMember]="'name'" (filteredReturn)="filteredList=$event" placeholder="{{'test.editSchedule.private.dateAndTime.inputSearch' | translate}}"></mat-select-filter>
                        <mat-option value="">
                          {{'test.editSchedule.private.dateAndTime.defaultTimezone' | translate}}</mat-option>
                        <mat-option *ngFor="let option of filteredList; let i=
                          index" [value]="option.name">
                          {{option?.name}}
                        </mat-option>
                      </mat-select>
                      <div *ngIf="f.timeZone.invalid && (f.timeZone.dirty ||
                        f.timeZone.touched )" class="alert alert-danger">
                        <div *ngIf="f.timeZone.errors?.required">{{'test.editSchedule.private.dateAndTime.timezoneError1' | translate}}</div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group settings pb-padding" [hidden]="!isFormLoaded">
              <div class="filter-section title"> <strong> Settings </strong>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.editSchedule.private.inputSettings.testScore' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput style-non" readonly formControlName="testTotalScore" [disabled]="isCompleted"><span>{{'test.editSchedule.private.inputSettings.labelmarks' | translate}}</span>
                  <div *ngIf="f.testTotalScore.invalid &&
                    (f.testTotalScore.dirty || f.testTotalScore.touched )" class="alert alert-danger">
                    <div *ngIf="f.testTotalScore.errors?.required">{{'test.editSchedule.private.inputSettings.testScoreErro1' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.editSchedule.private.labelQuestMandotry' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="maxAttempts">
                    <mat-slide-toggle formControlName="iallquestionsmandatory">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.editSchedule.private.inputSettings.testDuration' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput" formControlName="testDuration" min="0" max="9999" [disabled]="isCompleted"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"><span>{{'test.editSchedule.private.inputSettings.labelmin' | translate}}</span>
                  <div *ngIf="f.testDuration.invalid && (f.testDuration.dirty ||
                    f.testDuration.touched )" class="alert alert-danger">
                    <div *ngIf="f.testDuration.errors?.required">{{'test.editSchedule.private.inputSettings.testDurationError1' | translate}}</div>
                    <div *ngIf="f.testDuration.errors?.pattern">{{'test.editSchedule.private.inputSettings.testDurationError2' | translate}}</div>
                  </div>

                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.showToolSetting' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="maxAttempts">
                    <mat-slide-toggle formControlName="showTools">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.editSchedule.private.inputSettings.testPass' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput" formControlName="testPassingScore" min="0" (keyup)="testScoreChange()"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                    max="9999" [disabled]="isCompleted"><span>{{'test.editSchedule.private.inputSettings.labelmarks' | translate}}</span>
                    <div *ngIf="f.testPassingScore.invalid && (f.testPassingScore.dirty || f.testPassingScore.touched )" class="alert alert-danger">
                      <div *ngIf="f.testPassingScore.errors?.required">
                        {{'test.editSchedule.private.inputSettings.testPassError1' | translate}}
                      </div>
                      <!-- <div *ngIf="f.penaltyPoints.errors?.pattern">
                        {{'test.createSchedule.public.inputSettings.testDurationError2' | translate}}
                      </div> -->
                    </div>
                  <!-- <div *ngIf="f.testPassingScore.invalid &&
                    (f.testPassingScore.dirty || f.testPassingScore.touched )" class="alert alert-danger">
                    <div *ngIf="f.testPassingScore.errors?.required">{{'test.editSchedule.private.inputSettings.testPassError1' | translate}}</div>
                    <div *ngIf="f.testPassingScore.errors?.pattern">{{'test.editSchedule.private.inputSettings.testPassError2' | translate}}</div>
                  </div>

                  <div *ngIf="setTestScoremsg" class="alert alert-danger">
                    <div>{{'test.editSchedule.private.inputSettings.testPassError3' | translate}}</div>
                  </div> -->
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.showItemListSetting' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="maxAttempts">
                    <mat-slide-toggle formControlName="showItemList">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">Penalty points<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput" formControlName="penaltyPoints" min="0" (keyup)="checkTestValue()"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                    max="9999" [disabled]="isCompleted"><span>{{'test.editSchedule.private.inputSettings.labelmarks' | translate}}</span>
                    <div *ngIf="f.penaltyPoints.invalid && (f.penaltyPoints.dirty || f.penaltyPoints.touched )" class="alert alert-danger">
                      <div *ngIf="f.penaltyPoints.errors?.required">
                        {{'test.editSchedule.private.inputSettings.penaltyError1' | translate}}
                      </div>
                      <!-- <div *ngIf="f.penaltyPoints.errors?.pattern">
                        {{'test.createSchedule.public.inputSettings.testDurationError2' | translate}}
                      </div> -->
                    </div>
                  <!-- <div *ngIf="f.penaltyPoints.invalid && (f.penaltyPoints.dirty
                    || f.penaltyPoints.touched )" class="alert alert-danger">
                    <div *ngIf="f.penaltyPoints.errors?.required">Penalty points
                      is required
                    </div>
                    <div *ngIf="privateScheduleForm.controls.penaltyPoints.value<0">Please enter the Penalty points with positive integer</div>
                  </div>
                  <div *ngIf="setPenaltymsg" class="alert alert-danger">
                    <div>Penalty point should be less than Test passing score
                      and Total test
                      score</div>
                  </div> -->

                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.maxNumberofAttempts' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1">
                  <div class="maxAttempts">
                    <select class="form-control" [(ngModel)]="maxAttempts" (change)="onSelectMaxAttempts($event)" formControlName="MaxAttempts">
                      <option value="{{i}}" *ngFor='let in of counter(21) ;let i = index'>{{i}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-2"></div>
              </div>
              <div class="row">
                <div class="col-md-7"></div>
                <div class="col-md-2" *ngIf="isAllowAttempts">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.allowAttemptsAfter' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="isAllowAttempts">
                  <div class="allow-Attempts">
                    <select class="form-control" [(ngModel)]="weeks" formControlName="Weeks">
                      <option value="{{i}}" *ngFor='let in of counter(21) ;let i = index'>{{i}}</option>
                    </select>
                    <label class="attemptsLable">{{'test.createSchedule.private.inputSettings.weeks' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="isAllowAttempts">
                  <div class="allow-Attempts">
                    <select class="form-control" [(ngModel)]="days" formControlName="days">
                      <option value="{{i}}" *ngFor='let in of counter(31) ;let i = index'>{{i}}</option>
                    </select>
                    <label class="attemptsLable">{{'test.createSchedule.private.inputSettings.days' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="isAllowAttempts">
                  <div class="allow-Attempts">
                    <select class="form-control" [(ngModel)]="hours" formControlName="hours">
                      <option value="{{i}}" *ngFor='let in of counter(24) ;let i = index'>{{i}}</option>
                    </select>
                    <label class="attemptsLable">{{'test.createSchedule.private.inputSettings.hours' | translate}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="messages pb-padding" [hidden]="!isFormLoaded">
              <div class="title" id="mrg-bottom"> <strong>{{'test.editSchedule.private.labelMsg' | translate}}</strong>
              </div>
              <div class="filter-section"> <label>{{'test.editSchedule.private.labelPreTest' | translate}}<span class="red-asterisk">*</span></label></div>
              <div class="row">
                <div class="col-md-12 editor-cls">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                  </ngx-editor-menu>
                  <ngx-editor name='optionbox' [placeholder]="'test.editSchedule.private.placeholderEnter' | translate" class="form-control textarea" [editor]="editor"
                    formControlName="preMessageText">
                  </ngx-editor>
                  <div *ngIf="f.preMessageText.invalid &&
                    (f.preMessageText.dirty || f.preMessageText.touched )" class="alert alert-danger">
                    <div *ngIf="f.preMessageText?.errors?.minlength">{{'test.editSchedule.private.preTestError1' | translate}}</div>
                    <!-- <div *ngIf="f.preMessageText?.errors?.minlength">Minimum 2 characters
                                            required</div> -->
                    <div *ngIf="f.preMessageText?.errors?.maxlength">{{'test.editSchedule.private.preTestError2' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="filter-section post-wrapper"><label>{{'test.editSchedule.private.labelPostTest' | translate}}<span class="red-asterisk">*</span> </label></div>
              <div class="row" class="'mrg-top-msg">
                <div class=" editor-cls">
                  <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar">
                  </ngx-editor-menu>
                  <ngx-editor name='optionbox' [placeholder]="'test.editSchedule.private.placeholderEnter' | translate" class="form-control" [editor]="editor1" maxLength="1001"
                    formControlName="postMessageText">
                  </ngx-editor>
                  <div *ngIf="f.postMessageText.invalid &&
                    (f.postMessageText.dirty || f.postMessageText.touched )" class="alert alert-danger">
                    <div *ngIf="f.postMessageText?.errors?.minlength">{{'test.editSchedule.private.postTestError1' | translate}}</div>
                    <!-- <div *ngIf="f.postMessageText?.errors?.minlength">Minimum 2 characters
                                            required</div> -->
                    <div *ngIf="f.postMessageText?.errors?.maxlength">{{'test.editSchedule.private.postTestError2' | translate}}</div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
